module.exports = __webpack_public_path__ + "img/hotdog-top-map.fce548f5.jpg";